import { render } from "./CustomFormStep.vue?vue&type=template&id=4bc549da"
import script from "./CustomFormStep.vue?vue&type=script&lang=js"
export * from "./CustomFormStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__